import {
  Add,
  AddCircle,
  Apple,
  ArrowRight,
  Atm,
  Calculator,
  Cash,
  CheckmarkCircle,
  ChevronDown,
  ChevronRight,
  ChimeC,
  Clock,
  Close,
  CreditScore,
  Document,
  DollarSymbol,
  Facebook,
  Gear,
  Gift,
  Handshake,
  Heart,
  Help,
  Hyperlink,
  Infinite,
  LightBulb,
  Lightning,
  LinkedIn,
  List,
  Location,
  Lock,
  MembershipFilled,
  MobileDevice,
  MovePayMoney,
  OpenBook,
  PauseCircle,
  People,
  PeopleGroup,
  Pin,
  PlayCircle,
  Profile,
  Receipt,
  Remove,
  RemoveCircle,
  Rocket,
  Scissors,
  Shield,
  Speakerphone,
  SpotMe,
  Star,
  Sun,
  TaskList,
  Twitter,
  Wallet,
} from '@1debit/icons/dist/index.mjs';

export * from '@1debit/icons/dist/index.mjs';

const iconRegistry = {
  add: Add,
  add_circle: AddCircle,
  apple: Apple,
  arrow_right: ArrowRight,
  atm: Atm,
  calculator: Calculator,
  cash: Cash,
  checkmark_circle: CheckmarkCircle,
  chevron_down: ChevronDown,
  chevron_right: ChevronRight,
  chime_c: ChimeC,
  clock: Clock,
  close: Close,
  credit_score: CreditScore,
  document: Document,
  dollar_symbol: DollarSymbol,
  facebook: Facebook,
  gear: Gear,
  gift: Gift,
  handshake: Handshake,
  heart: Heart,
  help: Help,
  hyperlink: Hyperlink,
  infinite: Infinite,
  light_bulb: LightBulb,
  lightning: Lightning,
  linked_in: LinkedIn,
  list: List,
  location: Location,
  lock: Lock,
  membership_filled: MembershipFilled,
  mobile_device: MobileDevice,
  move_pay_money: MovePayMoney,
  open_book: OpenBook,
  pause_circle: PauseCircle,
  people: People,
  people_group: PeopleGroup,
  pin: Pin,
  play_circle: PlayCircle,
  profile: Profile,
  receipt: Receipt,
  remove: Remove,
  remove_circle: RemoveCircle,
  rocket: Rocket,
  scissors: Scissors,
  shield: Shield,
  speakerphone: Speakerphone,
  spot_me: SpotMe,
  star: Star,
  sun: Sun,
  task_list: TaskList,
  twitter: Twitter,
  wallet: Wallet,
} as const;

export type ChimeComIconToken = keyof typeof iconRegistry;

type ChimeComIcon = (typeof iconRegistry)[ChimeComIconToken];

export const isChimeComIconToken = (value: string): value is ChimeComIconToken =>
  Object.prototype.hasOwnProperty.call(iconRegistry, value);

export function getIconByKey(key: ChimeComIconToken): ChimeComIcon;
export function getIconByKey(key: string): ChimeComIcon | undefined;
export function getIconByKey(key: string): ChimeComIcon | undefined {
  return isChimeComIconToken(key) ? iconRegistry[key] : undefined;
}
